import React, { useState, useMemo } from "react";
import { FaPlus } from "react-icons/fa6";
import { WavyBackground } from "./WavyBackground";

const FAQ = ({ darkMode }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(null);

  const faqData = [
    {
      title: "What services does Kura Digital provide?",
      description:
        "We offer a bespoke 1-1 custom website design and development service, software development, and ongoing maintenance and support.",
    },
    {
      title: "How long does it take to build a website?",
      description:
        "This varies but it's something we cover as part of our process. The timeline varies depending on the project's complexity, but typically, a custom website takes 4-8 weeks from planning to deployment.",
    },
    {
      title: "Do you offer website maintenance services?",
      description:
        "Yes, we offer ongoing maintenance services to keep your website secure, updated, and running smoothly.",
    },
    {
      title: "Can you improve my website’s search engine ranking?",
      description:
        "Absolutely! Our SEO services focus on optimizing your website's structure, content, and performance to improve visibility on search engines.",
    },
    {
      title: "What businesses do you work with?",
      description:
        "Being a small-scale business ourselves, our main goal is to empower small businesses with grand aspirations and those looking to grow their online presence from the ground up. Not only that, but existing businesses who are looking for global reach.",
    },
    {
      title: "Why choose Kura Digital?",
      description:
        "Imagine having top priority for your project and the time and devotion that comes with that. Being a small digital agency allows us to provide a personal touch and a dedicated service to each and every client. Plus, we love a virtual coffee here!",
    },
  ];

  const handleAccordionClick = (index) => {
    setIsAccordionOpen((prevIndex) => (prevIndex === index ? null : index));
  };

  // Memoize the wavy background to avoid re-renders
  const wavyBackground = useMemo(() => (
    <div className="absolute inset-0 z-0 pointer-events-none">
      <WavyBackground
        colors={darkMode ? ["#1c1c1c", "#2c5364", "#203a43"] : ["#e5471f", "#7fc7e6", "#4b534e"]}
        waveWidth={60}
        backgroundFill={darkMode ? "#1c1c1c" : "#f5f3eb"}
        blur={15}
        speed="fast"
        waveOpacity={0.6}
      />
    </div>
  ), [darkMode]);

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-6 py-16 text-[#4b534e] dark:text-white">
      {/* Memoized Wavy Background */}
      {wavyBackground}

      <div className="relative z-10 w-full max-w-4xl text-center">
        <h1 className="text-4xl font-bold mb-10 text-[#4b534e]">Frequently Asked Questions</h1>
        <div className="max-w-3xl w-full mx-auto">
          {faqData.map((faq, index) => (
            <article 
              key={index} 
              className="border border-[#e5eaf2] rounded p-4 mb-4 shadow-md bg-white dark:bg-gray-900"
            >
              <div
                className="flex items-center justify-between cursor-pointer"
                onClick={() => handleAccordionClick(index)}
              >
                <h2 className="font-semibold text-xl">{faq.title}</h2>
                <FaPlus
                  className={`text-2xl transition-transform duration-300 ${
                    isAccordionOpen === index ? "rotate-45 text-[#3B9DF8]" : "text-[#4b534e] dark:text-gray-300"
                  }`}
                />
              </div>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  isAccordionOpen === index ? "max-h-40 mt-4 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-base">{faq.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;





